import store from "@src/reducers/store";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { sendSnackbarNotificationWhenMaximumAmountOfMonitoringNodesIsExceeded } from "./check-if-maximum-amount-of-monitoring-nodes-is-exceeded.ts";
import { updateStructureWasSaved } from "@src/reducers/your-reducer";

export const overwriteSelectedOurNodesWithNewDataAcquisitionValues = (
  dataAcquisitionType: string,
  pollingIntervalTime: number,
) => {
  const nodeManager = getNodeManager();

  nodeManager
    .getWriteDataAcquisitionTypeOnSelectedNodesHandler()
    .writeDataAcquisitionTypeOnSelectedNodes(
      dataAcquisitionType,
      pollingIntervalTime,
    );

  const maximumAmountOfMonitoringNodes =
    store.getState().yourSlice.maximum_number_of_monitored_items;

  sendSnackbarNotificationWhenMaximumAmountOfMonitoringNodesIsExceeded(
    getMachineStructureNodeset(),
    maximumAmountOfMonitoringNodes,
  );

  store.dispatch(updateStructureWasSaved(false));
};
